<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
   @if (tooltip) {
      <title>{{ tooltip }}</title>
   }
   <path d="M12,7.77L18.39,18H5.61L12,7.77M12,4L2,20H22"/>
</svg>